export default __webpack_public_path__ + "static/media/ISUHD6.95147727.mov";